import Vue from "vue";
import Router from "vue-router";
import SetUp from "@/components/SetUp";
import AllEmployees from "@/components/AllEmployees";
import AccountType from "@/components/AccountType";
import AccountSetup from "@/components/AccountSetup";
import Information from "@/components/Information";
import OtpVerify from "@/components/OtpVerify";
import ProfilePageUser from "@/components/ProfilePageUser";
import ProfilePageCompany from "@/components/ProfilePageCompany";
// import Notification from "@/components/Notification";
import Notifications from "@/components/Notifications";
import ManageRequests from "@/components/ManageRequests";
import PersonalInfoView from "@/components/PersonalInfoView";
import CompanyProfile from "@/components/CompanyProfile";
import AddEmployee from "@/components/AddEmployee";
import EditCompanyProfile from "@/components/EditCompanyProfile";
import EditUserProfile from "@/components/EditUserProfile";
import AccountProfile from "@/components/AccountProfile";
import BusinessProfile from "@/components/BusinessProfile";
import ConnectionList from "@/components/ConnectionLIst";
import FollowerList from "@/components/FollowerList";
import FollowingList from "@/components/FollowingList";
import ManageCompany from "@/components/ManageCompany";
// import DealsSettings from "@/components/SettingsComponents/DealsSettings";
// import TerritorySettings from "@/components/SettingsComponents/TerritorySettings";
import UserPermission from "@/components/SettingsComponents/UserPermission";
import ViewDeals from '@/components/Deals/ViewDeals';
import DealDetails from '@/components/Deals/DealDetails'
import {
    connect
} from "tls";
import Forbidden from "@/components/Forbidden.vue";
import AccessDenied from "@/components/AccessDenied.vue";
import Dashboard from "@/components/Dashboard";
import Register from "@/components/Register";
import CallReport from "@/components/CallReport";
import NewCallReports from "@/components/CallReportMeeting";
import NewCallReport from "@/components/CallReportMeeting";
import EditCallReport from "@/components/EditCallReport";
import ViewCallReport from "@/components/ViewCallReport";
import EditEmployee from "@/components/EditEmployee";
import RegisterInvited from "@/components/RegisterInvited";
import AddNewUser from "@/components/AddNewUser";
import SalesForecast from "@/components/SalesForecast";
import ListSalesForecast from "@/components/ListSalesForecast";
import ListSalesForecastFiltered from "@/components/ListSalesForecastFiltered";
import SettingsSalesForecast from "@/components/SettingsSalesForecast";
import CreateSalesForecast from "@/components/CreateSalesForecast";
import CallReportList from "@/components/CallReportList";
import CustomerList from "@/components/Customers/CustomerList";
import IndividualCustomerDashboard from "@/components/Customers/IndividualCustomerDashboard";
import Companyinfo from "@/components/Companyinfo";
import EmployeeList from "@/components/EmployeeList";
// import CompanyEmployees from "@/components/CompanyEmployees";
// import Dashboard from "@/components/Dashboard";
// import Companyinfo from "@components/Companyinfo";
import Login from "@/components/Login";
import Settings from "@/components/SettingsComponents/Settings";
import CreateLeads from "@/components/CreateLeads";
import CallReportReview from "@/components/CallReportReview";
import ViewCallReportAfterCreate from "@/components/ViewCallReportAfterCreate";
import EditTeam from "@/components/EditTeam";
import ListTeam from "@/components/ListTeam";
//import CreateContact from "@/components/CreateContact";
import CreateContact from "@/components/Contacts/CreateContact";
import EditContact from "@/components/Contacts/EditContact";
//import ListContacts from "@/components/ListContacts";
import ContactsListView from "@/components/Contacts/ContactsListView";
import ViewContact from "@/components/Contacts/ViewContact";
import IndividualContactDashboard from "@/components/Contacts/IndividualContactDashboard";
//import EditContact from "@/components/EditContact";
import ListLeads from "@/components/ListLeads";
import ViewLead from "@/components/ViewLead";
import EditLead from "@/components/EditLead";
import LeadsDashboard from "@/components/Dashboard/LeadsDashboard";
// import CreateCampaign from "@/components/CreateCampaign";
import ListCampaign from "@/components/ListCampaign";
import Leads from "@/components/Leads/CreateLeads";
import EditLeads from "@/components/Leads/EditLeads";
import EditLeadIndividual from "@/components/Leads/EditLeadIndividual";
import LeadsIndividual from "@/components/Leads/CreateLeadIndividual";
import SettingComponents from "@/components//SettingsComponents/Settings";
import ViewLeads from "@/components/Leads/ViewLeads";
import LeadProfileDashboard from "@/components/Leads/LeadProfileDashboard";
import ProductList from "@/components/products/ProductList"
import CreateCustomer from "@/components/Customers/CreateCustomer"
import EditCustomer from "@/components/Customers/EditCustomer"
import ViewCustomer from "@/components/Customers/ViewCustomer"
import CompanyProfileNew from "@/components/CompanyProfileNew";

// Survey Forms
import ListSurveyForms from "@/components/SurveyForms/ListSurveyForms";
import CreateSurveyForms from "@/components/SurveyForms/CreateSurveyForms";
import ViewSurveyForms from "@/components/SurveyForms/ViewSurveyForms"

//Deals
import CreateDeals from "@/components/Deals/CreateDeals";
import CreateNewDeals from "@/components/Deals/CreateNewDeals";
import CreateContactCustomerDeals from "@/components/Deals/CreateConCusDeals"
import CreateDealsNew from "@/components/Deals/createDealsNew";

//SalesForecast
import SalesCast from "@/components/SalesForeCast/SalesCast";
import ViewSalesForecast from "@/components/SalesForeCast/ViewSalesForecast";
import DisplayDeals from "@/components/SalesForeCast/DisplayDeals";

//Dashboard
import HomeDashboard from "@/components/Dashboard/HomeDashboard";
import SalesDashboard from "@/components/Dashboard/SalesDashboard";
import ContactsDashboard from "@/components/Dashboard/ContactsDashboard";
import SurveyDashboard from "@/components/Dashboard/SurveyDashboard";
import DealsDashboard from "@/components/Dashboard/DealsDashboard";
import CallReportDashboard from "@/components/Dashboard/CallReportDashboard"
import SalesForecastDashboard from "@/components/Dashboard/SalesForecastDashboard"
import CampaignsDashboard from "@/components/Dashboard/CampaignsDashboard"

//Campaigns
import CreateCampaignEmail from "@/components/Campaign/Email/CreateCampaignEmail";
import EditCampaignEmail from "@/components/Campaign/Email/EditCampaignEmail";
import CampaignEmailListView from "@/components/Campaign/Email/CampaignEmailListView";
import PreviewTemplateThree from "@/components/Campaign/Email/PreviewTemplateThree";
import PreviewTemplateTwo from "@/components/Campaign/Email/PreviewTemplateTwo";
import PreviewTemplateOne from "@/components/Campaign/Email/PreviewTemplateOne";
import CampaignEmailDetails from "@/components/Campaign/Email/CampaignEmailDetails"
import ApproveEmail from "@/components/Campaign/Email/ApproveEmail"
import CreateCampaignSms from "@/components/Campaign/Sms/CreateCampaignSms";
import CampaignSmsListView from "@/components/Campaign/Sms/campaignSmsListView/";
import ApproveSms from "@/components/Campaign/Sms/ApproveSmsCampaign.vue"
import CampaignSmsDetails from "@/components/Campaign/Sms/CampaignSmsDetails"

//Teams
import CreateTeam from "@/components/Teams/CreateTeam";
import TeamListView from "@/components/Teams/TeamListView"
import ViewTeam from "@/components/Teams/ViewTeam"

//Reminders
import CreateReminder from "@/components/Reminders/CreateReminder";
import RemindersListView from "@/components/Reminders/RemindersListView";

//ActivityLog
import ActivityLog from "@/components/Activitylogs/ActivityLog"

//Requests
import Requests from "@/components/Requests/Requests";

//Schedule Meetings
import ScheduleMeeting from "@/components/ScheduleMeeting/ScheduleMeetingListView";
import ScheduleMeetingById from "@/components/ScheduleMeeting/ScheduleMeetingListView";
import ScheduleMeetingView from "@/components/ScheduleMeeting/ScheduleMeetingViewDetails";
import ScheduleMeetingViews from "@/components/ScheduleMeeting/ScheduleMeetingViewDetails";

//Auctions
import CreateAuction from "@/components/Auction/CreateAuction";
import AuctionListView from "@/components/Auction/AuctionListView";
import BidderListView from "@/components/Auction/BidderListView";
import BidderInfoView from "@/components/Auction/BidderInfoView";
import PreviewAuction from "@/components/Auction/PreviewAuction";
import ViewAuction from "@/components/Auction/ViewAuction";
import EditAuction from "@/components/Auction/EditAuction";
import EditPreviewAuction from "@/components/Auction/EditPreviewAuction";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "HomeDashboard",
            component: HomeDashboard
        },
        {
            path: "/contactsDashboard",
            name:"ContactsDashboard",
            component: ContactsDashboard
        },
        {
            path: "/salesDashboard",
            name: "SalesDashboard",
            component: SalesDashboard
        },
        {
            path: "/surveyDashboard",
            name: "SurveyDashboard",
            component: SurveyDashboard
        },
        {
            path: "/dealsDashboard",
            name: "DealsDashboard",
            component: DealsDashboard
        },
        {
            path: "/callreportDashboard",
            name: "CallReportDashboard",
            component: CallReportDashboard
        },
        {
            path: "/forecastDashboard",
            name: "forecastDashboard",
            component: SalesForecastDashboard
        },
        {
            path: "/campaignsDashboard",
            name: "campaignsDashboard",
            component: CampaignsDashboard
        },
        // {
        //   path: "/connections/:request_type/:id",
        //   name: "ConnectionList",
        //   component: ConnectionList,
        // },
        {
            path: "/connections/:request_type/:id",
            name: "ConnectionList",
            component: ConnectionList,
        },
        {
            path: "/followers",
            name: "FollowerList",
            component: FollowerList,
        },
        {
            path: "/company_profile",
            name: "CompanyProfileNew",
            component: CompanyProfileNew,
        },
        {
            path: "/following",
            name: "FollowingList",
            component: FollowingList,
        },
        {
            path: "/create_contact/:id",
            name: "CreateContact",
            component: CreateContact,
        },
        {
            path: "/edit_contact/:id",
            name: "EditContact",
            component: EditContact,
        },
        {
            path: "/manageRequests",
            name: "ManageRequests",
            component: ManageRequests,
        },
        {
            path: "/businessProfile/:id",
            name: "BusinessProfile",
            component: BusinessProfile,
        },
        {
            path: "/addemployee",
            name: "AddEmployee",
            component: AddEmployee,
            props: true,
        },

        {
            path: "/addnewuser",
            name: "AddNewUser",
            component: AddNewUser,
        },
        // {
        //   path: "/",
        //   name: "ContactsManage",
        //   component: ContactsManage,
        // },
        {
            path: "/setup",
            name: "SetUp",
            component: SetUp,
        },
        {
            path: "/accounttype",
            name: "AccountType",
            component: AccountType,
        },
        {
            path: "/accountsetup",
            name: "AccountSetup",
            component: AccountSetup,
        },
        {
            path: "/information",
            name: "Information",
            component: Information,
        },
        {
            path: "/verifyOtp",
            name: "OtpVerify",
            component: OtpVerify,
        },
        // {
        //     path: "/notification",
        //     name: "Notification",
        //     component: Notification,
        // },
        {
            path: "/companyprofile/:id",
            name: "CompanyProfile",
            component: CompanyProfile,
            props: true,
        },
        {
            path: "/editcompanyprofile/:id",
            name: "EditCompanyProfile",
            component: EditCompanyProfile,
            props: true,
        },
        {
            path: "/userprofile/:id",
            name: "AccountProfile",
            component: AccountProfile,
            props: true,
        },
        // {
        //     path: "/",
        //     name: "Dashboard",
        //     component: Dashboard,
        // },
        {
            path: "/editUserprofile/:id",
            name: "EditUserProfile",
            component: EditUserProfile,
        },
        {
            path: "/register",
            name: "Register",
            component: Register,
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
        },
        {
            path: "/registerInvited/:id",
            name: "RegisterInvited",
            component: RegisterInvited,
        },
        {
            path: "/managecompany",
            name: "ManageCompany",
            component: ManageCompany,
        },
        {
            path: "/callreport",
            name: "CallReport",
            component: CallReport,
        },
        {
            path: "/callreports/new/:module_type/:id",
            name: "NewCallReports",
            component: NewCallReports,
        },
        {
            path: "/callreport/new",
            name: "NewCallReport",
            component: NewCallReport,
        },
        {
            path: "/copycallreport/:id",
            name: "CopyCallReport",
            component: CallReport,
        },
        {
            path: "/editcallreport/:id",
            name: "EditCallReport",
            component: EditCallReport,
        },
        {
            path: "/viewcallreport/:id",
            name: "ViewCallReport",
            component: ViewCallReport,
        },
        {
            path: "/callreportlist",
            name: "CallReportList",
            component: CallReportList,
        },
        {
            path: "/salesforecast",
            name: "SalesForecast",
            component: SalesForecast,
        },
        {
            path: "/listsalesforecast",
            name: "ListSalesForecast",
            component: ListSalesForecast,
        },
        {
            path: "/listsalesforecastfiltered",
            name: "listsalesforecastfiltered",
            component: ListSalesForecastFiltered,
        },
        {
            path: "/settingssalesforecast",
            name: "SettingsSalesForecast",
            component: SettingsSalesForecast,
        },
        {
            path: "/createsalesforecast",
            name: "CreateSalesForecast",
            component: CreateSalesForecast,
        },
        {
            path: "/editemployee/:id",
            name: "EditEmployee",
            component: EditEmployee,
            props: true,
        },
        // {
        //   path: "/Companyinfo",
        //   name: "Companyinfo",
        //   component: Companyinfo,
        // },
        {
            path: "/allemployees",
            name: "AllEmployees",
            component: AllEmployees,
        },
        {
            path: "/employeelist",
            name: "EmployeeList",
            component: EmployeeList,
        },
        {
            path: "/customerlist",
            name: "CustomerList",
            component: CustomerList,
        },
        {
            path: "/settings",
            name: "Settings",
            component: Settings,
        },
        {
            path:"/CreateTeam",
            name:"CreateTeam",
            component:CreateTeam,
        },
        {
            path: "/createLeads",
            name: "CreateLeads",
            component: CreateLeads,
        },
        {
            path: "/leads/createLeads/:id",
            name: "Leads",
            component: Leads,
        },
        {
            path: "/leads/editLeads/:id",
            name: "EditLeads",
            component: EditLeads,
        },
        {
            path: "/leads/editLeadIndividual/:id",
            name: "EditLeadIndividual",
            component: EditLeadIndividual,
        },
        {
            path: "/leads/createLeads/individual/:id",
            name: "LeadsIndividual",
            component: LeadsIndividual
        },
        {
            path: "/leads/viewLeads/:id",
            name: "ViewLeads",
            component: ViewLeads,
        },
        {
            path: "/leads/LeadProfile_Dashboard",
            name: "LeadProfileDashboard",
            component: LeadProfileDashboard,
        },
        {
            path: "/Contacts/IndividualContact_Dashboard/:id",
            name: "IndividualContactDashboard",
            component: IndividualContactDashboard,
        },
        {
            path: "/Customers/IndividualCustomer_Dashboard/:id",
            name: "IndividualCustomerDashboard",
            component: IndividualCustomerDashboard,
        },
        {
            path: "/leadsDashboard",
            name: "LeadsDashboard",
            component: LeadsDashboard,
        },
        {
            path: "/callreportreview",
            name: "CallReportReview",
            component: CallReportReview,
        },
        {
            path: "/copycallreportreview/:id",
            name: "CopyCallReportReview",
            component: CallReportReview,
        },
        {
            path: "/viewcallreportaftercreate/:id",
            name: "ViewCallReportAfterCreate",
            component: ViewCallReportAfterCreate,
        },
        {
            path: "/editcallreportreview/:id",
            name: "Editcallreportreview",
            component: CallReportReview,
        },
        {
            path: "/editteam/:id",
            name: "EditTeam",
            component: EditTeam,
        },
        {
            path: "/listteam",
            name: "ListTeam",
            component: ListTeam,
        },
        // {
        //     path: "/listcontacts",
        //     name: "ContactListView",
        //     component: ContactListView,
        // },
        {
            path: "/contacts/list_contacts",
            name: "ContactsListView",
            component: ContactsListView,
        },
        {
            path: "/contacts/view_contact/:id",
            name: "ViewContact",
            component: ViewContact,
        },
        {
            path: "/listleads",
            name: "ListLeads",
            component: ListLeads,
        },
        {
            path: "/viewlead/:id",
            name: "ViewLead",
            component: ViewLead,
        },
        {
            path: "/editlead/:id",
            name: "EditLead",
            component: EditLead,
        },
        // {
        //     path: "/createCampaign",
        //     name: "CreateCampaign",
        //     component: CreateCampaign,
        // },
        {
            path: "/listCampaign",
            name: "ListCampaign",
            component: ListCampaign,
        },
        {
            path: "/products/ProductList",
            name: "ProductList",
            component: ProductList
        },
        {
            path: "/settingComponents",
            name: "SettingComponents",
            component: SettingComponents
        },
        {
            path: "/create_customer/:id",
            name: "CreateCustomer",
            component: CreateCustomer
        },
        {
            path: "/edit_customer/:id",
            name: "EditCustomer",
            component: EditCustomer
        },
        {
            path: "/view_customer/:id",
            name: "ViewCustomer",
            component: ViewCustomer
        },
        /**************************** Survey Forms  *******************************/
        {
          path: "/surveyform/listview",
          name: "ListSurveyForms",
          component: ListSurveyForms
        },
        {
          path: "/surveyform/create",
          name: "CreateSurveyForms",
          component: CreateSurveyForms
        },
        {
          path: "/surveyform/view/:id",
          name: "ViewSurveyForms",
          component: ViewSurveyForms
        },
        /**************************** Deals  *******************************/
        {
            path: "/deals/create/:id",
            name: "CreateDeals",
            component: CreateDeals
        },
        {
            path: "/deals/createdeal/:id",
            name: "CreateContactCustomerDeals",
            component: CreateContactCustomerDeals
        },
        {
            path: "/deals/createdeals/:id",
            name: "CreateNewDeals",
            component: CreateNewDeals
        },
        {
            path: "/deals/createdeals/:id",
            name: "CreateDealsNew",
            component: CreateDealsNew
        },
        {
            path: "/deals/viewdeals/:id",
            name: "ViewDeals",
            component: ViewDeals,
        },
        {
            path: "/deals/dealdetails/:id",
            name: "DealDetails",
            component: DealDetails,
        },
        /**************************** User Permission  *******************************/,
        {
            path: "/settingComponents/user_permission",
            name: "UserPermission",
            component: UserPermission,
        },

        /**************************** Deals Settings  *******************************/
        // {
        //     path: "/deals/dealssettings",
        //     name: "DealsSettings",
        //     component: DealsSettings
        // },
        // {
        //     path: '/deals/territorysettings',
        //     name: 'TerritorySettings',
        //     component: TerritorySettings,
        // },
        {
            path: "/salesForeCast/salesCast/:id",
            name: "SalesCast",
            component: SalesCast,
        },
        {
            path: "/salesForeCast/view_sales_forecast/:id",
            name: "ViewSalesForecast",
            component: ViewSalesForecast,
        },
        {
            path: "/salesForeCast/view_deals/:id",
            name: "DisplayDeals",
            component: DisplayDeals,
        },
        /**************************** Campaign  *******************************/
        /******* EMail *******/
        {
            path: "/campaign/email/createCampaignEmail/",
            name: "CreateCampaignEmail",
            component: CreateCampaignEmail
        },
        {
            path: "/campaign/email/createCampaignEmail/:id",
            name: "CreateCampaignEmail",
            component: CreateCampaignEmail
        },
        {
            path: "/campaign/email/editCampaignEmail/:id",
            name: "EditCampaignEmail",
            component: EditCampaignEmail
        },
        {
            path: "/campaign/email/campaignEmailListView/",
            name: "campaignEmailListView",
            component: CampaignEmailListView
        },
        {
            path: "/campaign/email/previewTemplateThree/",
            name: "PreviewTemplateThree",
            component: PreviewTemplateThree
        },
        {
            path: "/campaign/email/previewTemplateThree/:id",
            name: "PreviewTemplateThree",
            component: PreviewTemplateThree
        },
        {
            path: "/campaign/email/approveEmail/:id",
            name: "ApproveEmail",
            component: ApproveEmail
        },
        {
            path: "/campaign/email/previewTemplateTwo/",
            name: "PreviewTemplateTwo",
            component: PreviewTemplateTwo
        },
        {
            path: "/campaign/email/previewTemplateOne/",
            name: "PreviewTemplateOne",
            component: PreviewTemplateOne
        },
        {
            path: "/campaign/email/campaignEmailDetails",
            name: "CampaignEmailDetails",
            component: CampaignEmailDetails
        },
        /******* SMS *******/
        {
            path: "/campaign/sms/createCampaignSms/",
            name: "CreateCampaignSms",
            component: CreateCampaignSms
        },
        {
            path: "/campaign/sms/createCampaignSms/:id",
            name: "CreateCampaignSms",
            component: CreateCampaignSms
        },
        {
            path: "/campaign/sms/campaignSmsListView/",
            name: "CampaignSmsListView",
            component: CampaignSmsListView
        },
        {
            path: "/campaign/sms/approveSmsCampaign/:id",
            name: "ApproveSms",
            component: ApproveSms
        },
        {
            path: "/campaign/sms/campaignSmsDetails",
            name: "CampaignSmsDetails",
            component: CampaignSmsDetails
        },
        /************************************ Teams ******************************************/
        {
            path: "/teams/CreateTeam",
            name: "CreateTeam",
            component: CreateTeam,
        },
        {
            path: "/teams/TeamListView",
            name: "TeamListView",
            component: TeamListView,
        },
        {
            path: "/teams/ViewTeam/:id",
            name: "ViewTeam",
            component: ViewTeam,
        },

        /************************************ Reminders ******************************************/
        {
            path: "/Reminders/CreateReminder",
            name: "CreateReminder",
            component: CreateReminder,
        },
        {
            path: "/Reminders/RemindersListView",
            name: "RemindersListView",
            component: RemindersListView,
        },
        /************************************ Others ******************************************/
        {
            path: "/forbidden",
            name: "Forbidden",
            component: Forbidden,
        },
        {
            path: "/accessDenied",
            name: "AccessDenied",
            component: AccessDenied,
        },
        {
            path: "/activitylogs/activityLog/:id",
            name: "ActivityLog",
            component: ActivityLog
        },
        /**************************************Notifications **************************************/
        {
            path: "/notifications",
            name: "Notifications",
            component: Notifications,
        },
        /************************************** Requests **************************************/
        {
            path: "/requests",
            name: "Requests",
            component: Requests
        },
        /************************************** ScheduleMeeting **************************************/
        {
            path: "/teams/schedulemeeting",
            name: "ScheduleMeeting",
            component: ScheduleMeeting
        },
        {
            path: "/contacts/schedulemeeting/:module_type/:id",
            name: "ScheduleMeetingById",
            component: ScheduleMeetingById
        },
        {
            path: "/Customers/schedulemeeting/:module_type/:id",
            name: "ScheduleMeetingById",
            component: ScheduleMeetingById
        },
        {
            path: "/leads/schedulemeeting/:module_type/:id/:stage_name",
            name: "ScheduleMeetingById",
            component: ScheduleMeetingById
        },
        /************************************** ScheduleMeetingViewDetails **************************************/
        {
            path: "/contacts/schedulemeetingview/:module_type/:module_id/:id",
            name: "ScheduleMeetingView",
            component: ScheduleMeetingView
        },
        {
            path: "/Customers/schedulemeetingview/:module_type/:module_id/:id",
            name: "ScheduleMeetingView",
            component: ScheduleMeetingView
        },
        {
            path: "/leads/schedulemeetingview/:module_type/:module_id/:id/:stage_name",
            name: "ScheduleMeetingView",
            component: ScheduleMeetingView
        },
        {
            path: "/teams/schedulemeetingview/:module_type/:module_id/:id",
            name: "ScheduleMeetingView",
            component: ScheduleMeetingView
        },
        {
            path: "/teams/schedulemeetingviews/:id",
            name: "ScheduleMeetingViews",
            component: ScheduleMeetingViews
        },
        /**************************** Auctions *******************************/
        {
            path: "/auction/create",
            name: "CreateAuction",
            component: CreateAuction
        },
        {
            path: "/auction/listview",
            name: "AuctionListView",
            component: AuctionListView
        },
        {
            path: "/auction/bidderlistview/:id",
            name: "BidderListView",
            component: BidderListView
        },
        {
            path: "/auction/bidderinfoview/:id",
            name: "BidderInfoView",
            component: BidderInfoView
        },
        {
            path: "/auction/preview",
            name: "PreviewAuction",
            component: PreviewAuction
        },
        {
            path: "/auction/view/:id",
            name: "ViewAuction",
            component: ViewAuction
        },
        {
            path: "/auction/edit/:id",
            name: "EditAuction",
            component: EditAuction
        },
        {
            path: "/auction/editpreview/:id",
            name: "EditPreviewAuction",
            component: EditPreviewAuction
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js